import profileEn from './locales/profile.en.json';
import profileJa from './locales/profile.ja.json';
import capabilityEn from './locales/capability.en.json';
import capabilityJa from './locales/capability.ja.json';
import graphsEn from './locales/graphs.en.json';
import graphsJa from './locales/graphs.ja.json';

export const localizedProfiles = {
    en: {...profileEn, capabilityModel: capabilityEn},
    ja: {...profileJa, capabilityModel: capabilityJa},
};
export const localizedGraphs = {en: graphsEn, ja: graphsJa};
export const localizedFigures = {
    "en": {
        "query": {
            "title": "Query Intelligence | Semantics and controlled analytics",
            "caption": "Business semantics align metric definitions, route tasks by complexity and return verifiable results through controlled data services."
        },
        "gamefactory": {
            "title": "Game Factory | Constrained generation and authoritative runtime",
            "caption": "A persistent control plane coordinates conditional definitions and role-based generation. Artifacts enter an authoritative runtime through controlled admission, retaining numerical, fairness and delivery evidence."
        },
        "knowledge": {
            "title": "Enterprise knowledge | Compilation and evidence-driven investigation",
            "caption": "The production side publishes consistent knowledge builds; the consumption side retrieves and investigates until evidence is sufficient for a cited conclusion."
        },
        "talent": {
            "title": "Talent Mining | Role competencies and behavioral evidence",
            "caption": "Role standards guide initial assessment and follow-up questions. Actual interview behavior supports comparison and conclusions; methodology and outcome validation remain separate."
        },
        "platform": {
            "title": "AI LAB | Three paradigms and shared engineering",
            "caption": "Language engineering, orchestration and preference alignment shape Agent context, execution and evaluation; shared services and engineering SOPs support continuous delivery across applications."
        },
        "lattice": {
            "title": "LatticeFlow | Unified logs, computation and data services",
            "caption": "Ingestion and replay feed a unified log and the Flink/Rust processing path. Coordinated commits connect layered storage, data services and business analytics."
        },
        "bilm": {
            "title": "BILM | Bitmap indexing and incremental persistence",
            "caption": "A unidirectional bitmap index supports set algebra and reverse-containment queries, with WAL, incremental snapshots and consistent cut points for recovery."
        },
        "global-recommendation": {
            "title": "Global recommendation | State-aware, risk-constrained ranking",
            "caption": "Aggregate features and behavioral sequences drive state segmentation; multi-objective ranking and hard risk constraints determine recommendations."
        },
        "kol": {
            "title": "KOL Intelligence | Multi-route retrieval and social recommendation",
            "caption": "Semantic candidates pass through similarity fusion and tier strategies, serving Feed distribution and creator combinations that satisfy relationship constraints."
        },
        "motion": {
            "title": "Xingtong text2motion | Semantic retrieval and pose correction",
            "caption": "Language is mapped to motion intent; retrieved clips are composed and checked for pose and timing before driving character animation."
        },
        "carbon": {
            "title": "Carbon policy simulation | MDP and causal interpretation",
            "caption": "A policy Agent selects interventions in a simulated environment. Delayed feedback and reward shaping guide long-term trade-offs; multi-scenario replay supports interpretation."
        }
    },
    "ja": {
        "query": {
            "title": "Query Intelligence｜業務意味と統制された分析",
            "caption": "業務意味で指標の定義を統一し、複雑さに応じてタスクを振り分け、統制されたデータサービスから検証可能な結果を返す。"
        },
        "gamefactory": {
            "title": "Game Factory｜制約付き生成と権威ある実行系",
            "caption": "永続的な制御系が条件付き定義と役割別の生成を編成する。生成物は検証を経て権威ある実行系に入り、数値・公平性・引き渡しの検証記録を保持する。"
        },
        "knowledge": {
            "title": "企業ナレッジ｜知識コンパイルと根拠に基づく調査",
            "caption": "生成側は整合した知識ビルドを公開し、利用側は根拠の充足性を確認しながら検索・調査し、出典付きの回答を生成する。"
        },
        "talent": {
            "title": "Talent Mining｜職務コンピテンシーと行動根拠",
            "caption": "職務基準に基づいて初期評価と追加質問を設計し、実際の面接行動から比較・判断する。評価方法の規則と成果の検証を区別する。"
        },
        "platform": {
            "title": "AI LAB｜三つの設計原則と共通開発基盤",
            "caption": "言語工学・タスク編成・選好調整が Agent のコンテキスト、実行、評価を規定し、共通機能と開発 SOP が複数業務の継続的な提供を支える。"
        },
        "lattice": {
            "title": "LatticeFlow｜統一ログ・計算・データサービス",
            "caption": "収集・再生データを統一ログから Flink/Rust の処理系に渡し、協調したコミットで階層別ストレージ、データサービス、業務分析につなぐ。"
        },
        "bilm": {
            "title": "BILM｜ビットマップ索引と増分永続化",
            "caption": "単方向ビットマップ索引で集合演算と逆包含検索を扱い、WAL・増分スナップショット・整合した切断点によって復旧を支える。"
        },
        "global-recommendation": {
            "title": "グローバル推薦｜状態認識とリスク制約付きランキング",
            "caption": "集約特徴と行動系列から状態を分類し、多目的ランキングとリスクのハード制約を通じて推薦を決める。"
        },
        "kol": {
            "title": "KOL Intelligence｜複数経路検索とソーシャル推薦",
            "caption": "意味検索の候補を類似度統合と層別戦略で配分し、Feed 配信と関係制約を満たすクリエイターの組み合わせに活用する。"
        },
        "motion": {
            "title": "星瞳 text2motion｜意味に基づく動作検索と姿勢補正",
            "caption": "自然言語を動作意図に変換し、検索したクリップを合成する。姿勢と時間的整合性を確認してキャラクターの動作に反映する。"
        },
        "carbon": {
            "title": "カーボン政策シミュレーション｜MDP と因果解釈",
            "caption": "政策 Agent が模擬環境で介入を選択する。遅延フィードバックと報酬設計で長期的な選択を導き、複数シナリオの再生で方策を解釈する。"
        }
    }
};
